import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon_editor_move.svg'
import _imports_1 from '../assets/icon_editor_section_add.svg'
import _imports_2 from '../assets/icon_x_mark.svg'


const _withScopeId = n => (_pushScopeId("data-v-ba4c7dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "section-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "text",
        placeholder: _ctx.id,
        maxlength: "60",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }, null, 40, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add-section', _ctx.order))),
        src: _imports_1,
        alt: "Добавить секцию ниже"
      }),
      _hoisted_6
    ])
  ]))
}